import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { api } from "../utils/hostname";
import { currentCurrency } from "../redux/user/selectors";
import url from "../url";

type RollbackResponse = {
  data: {
    rollbackSoon: boolean;
    rollbackDate: string;
  };
};

const request = (currency: string) =>
  api(true, true).get<RollbackResponse>(url.config.api.loyalty.rollbackStatus, {
    params: {
      currency,
    },
  });

export const useRollbackInfo = () => {
  const currencyCode = useSelector(currentCurrency);

  const { data } = useQuery({
    queryKey: ["rollback"],
    queryFn: () => request(currencyCode),
    staleTime: 5 * 60 * 1000,
  });

  return {
    rollback: data?.data?.data || { rollbackSoon: false, rollbackDate: "" },
  };
};
